module.exports = __webpack_public_path__ + "src/components/icon-vintage-eyeglasses.9592b1dbec2f8d2179e3d2449088b51a.svg";